import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "anak";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const masterRegion = "Master/Region/list/";
export const masterRelationshipStatus = "Master/List/familyRelationshipStatus/";
export const masterParents = "Kepegawaian/Anak/parents/";
export const masterMaritalStatus = "Master/MaritalStatus/list/";
export const masterGajiwebSatker = "Master/GajiWeb/listPegawai/";

export const anakCreate = "Kepegawaian/Anak/create/";
export const anakList = "Kepegawaian/Anak/list/";
export const anakDetail = "Kepegawaian/Anak/detail/";
export const anakUpdate = "Kepegawaian/Anak/update/";
export const anakUpdateFile = "Kepegawaian/Anak/updatefile/";
export const anakInactive = "Kepegawaian/Anak/inactive/";
export const anakActive = "Kepegawaian/Anak/active/";
export const anakApprove = "Kepegawaian/Anak/approve/";
export const fileTemplate = "Master/Templatesurat/detail/";
//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      return await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
